<div class="devo-donors-gifts-view-part">

	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="gifts()"></grid-content>

</div>